import { useState, useCallback, type FormEvent, type ChangeEvent } from 'react';
import { Input, Button } from '../common';
import { useNFTStore } from '../../stores';

export function NFTSearchInput() {
  const { searchQuery, setSearchQuery, fetchNFTByNum, isLoading } = useNFTStore();
  const [validationError, setValidationError] = useState<string | null>(null);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setSearchQuery(value);

      if (validationError && value.length > 0) {
        const num = parseInt(value, 10);
        if (!isNaN(num) && num > 0) {
          setValidationError(null);
        }
      }
    },
    [setSearchQuery, validationError]
  );

  const handleSubmit = useCallback(
    async (e: FormEvent) => {
      e.preventDefault();

      const num = parseInt(searchQuery, 10);

      if (isNaN(num) || num <= 0) {
        setValidationError('Please enter a valid NFT number');
        return;
      }

      setValidationError(null);
      await fetchNFTByNum(num);
    },
    [searchQuery, fetchNFTByNum]
  );

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-xl">
      <div className="flex gap-3 items-start">
        <div className="flex-1">
          <Input
            type="number"
            value={searchQuery}
            onChange={handleChange}
            placeholder="enter nub number"
            error={validationError}
            disabled={isLoading}
            aria-label="NFT number"
            min="1"
            className="text-lg"
          />
        </div>
        <Button
          type="submit"
          variant="game3d"
          size="lg"
          isLoading={isLoading}
          disabled={!searchQuery.trim()}
          className="shrink-0 px-8"
        >
          Search
        </Button>
      </div>
    </form>
  );
}
